import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import FehlerlisteSection from "@/components/FehlerlisteSection";
import { ClipboardList } from "lucide-react";

export default function Fehlerliste() {
  const { user } = useAuth();
  const officer = user ? `${user.name}${user.dienstnummer ? ` (${user.dienstnummer})` : ""}` : "";

  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Verwaltung"
        title="Fehlerliste"
        description="Erfasste Fehler mit Aktenbezug, Zuständigkeit und Status. Erledigte Einträge werden nach 1 Minute automatisch archiviert."
        icon={ClipboardList}
      />
      <div className="p-8">
        <FehlerlisteSection officer={officer} />
      </div>
    </div>
  );
}
